define(function (require, exports, module) {
    var GDC = require('./lib/main');
    return GDC;
});